import React from 'react';

import {SidepanelTabState} from './useFlowchartSidepanelUnsavedChanges';

export interface FlowchartSidepanelUnsavedChangesContextValue {
  registerTab: (params: SidepanelTabState) => void;
  unregisterTab: (tab: string) => void;
  setIsTabDirty: (tab: string, isDirty: boolean) => void;
}

export const FlowchartSidepanelUnsavedChangesContext =
  React.createContext<FlowchartSidepanelUnsavedChangesContextValue>({
    registerTab: () => {},
    unregisterTab: () => {},
    setIsTabDirty: () => {},
  });
